var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="CDB-NavMenu-inner CDB-NavMenu-inner--legends CDB-Text is-semibold CDB-Size-medium js-tabs-container"></ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/builder/embed/tabs/tabs.tpl
// module id = 2043
// module chunks = 2